module.exports = __webpack_public_path__ + "img/logo.e210f19c.png";